import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import About from "./components/About";
import Formations from "./components/Formations";
import LaFormation from "./components/LaFormation";
import Financements from "./components/Financements";
import Testimonials from "./components/Testimonials";
import Assistant from "./components/Assistant";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Admin from "./components/Admin";
import { Toaster } from "./components/ui/toaster";

const Home = () => (
  <div className="min-h-screen bg-[#fbfaf7]">
    <Navbar />
    <main>
      <Hero />
      <TrustBar />
      <About />
      <Formations />
      <LaFormation />
      <Financements />
      <Testimonials />
      <Assistant />
      <Contact />
    </main>
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
